
import React from "react";
import '../style/About.css';

function About() {
  return (
    <div className="info-section">
      <h3>About eSignet</h3>
      <p>
        eSignet is a secure platform that simplifies identity verification with fast, reliable sign-ins using trusted credentials.
      </p>
      <p>
        Our mission is to enhance digital trust and make authentication seamless for businesses and users alike.
      </p>
    </div>
  );
}

export default About;

